export enum PagesEnum {
  InitGetPage = 'InitGetPage',
  SuccessGetPage = 'SuccessGetPage',
  FailGetPage = 'FailGetPage',
  CleanPagesAlerts = 'CleanPagesAlerts',
}
